export default {
  //登录
  LOGIN_API: '/uaa/auth/form',
  //验证码
  VALIDATE_CODE_API: '/uaa/auth/code/image',
  //菜单树
  MENUS_API: '/maindata/menu/listUserMenus',
  //获取菜单编码
  GET_MENU_CODE_API: '/maindata/menu/listMenuCodeByMenuUrl',
  //获取公司列表接口
  COMPLANLY_API: '/webauth/menu/listUserMenus',
  //获取应用列表
  GET_APPLICATION_LIST_API: '/maindata/application/getApplicationByTenantCode',
  // 获取详情按钮权限
  GET_ROLE_OTHER_BUTTON: '/maindata/role/getRoleOtherButton',
  // 延长token
  REFRESH_TOKEN_EXIR: '/uaa/oauth/refreshToken',
};
